<template>
  <div id="new_list_outer">
    <div v-if="itemList != null">
      <ul class="list-group" v-if="itemList.length > 0">
        <li class="list-group-item" v-for="(item, index) in itemList" :key="'offic_news_' + index">
          <a :href="itemSrc(item)" target="_blank">
<!--            <div>{{item.actionTitle}}</div>-->
            <hot-label :title="item.actionTitle" :flag="item.flag" :flagInvalidTIme="item.flagInvalidTIme"></hot-label>
            <div>{{itemDate(item)}}</div>
          </a>
        </li>
      </ul>
      <div v-else style="font-size: 1.5rem;padding-top: 120px;text-align: center;min-height: 300px">
        暂无内容
      </div>
    </div>

    <div style="padding-right: 30px;">
      <bottom-paginator
        v-bind:current="pageIndex"
        v-bind:total="totalPage"
        v-bind:paginator-type="1"
        v-on:itemClicked="paginatorClicked"
      />
    </div>
  </div>
</template>

<script>
import BottomPaginator from "../BottomPaginator";
import GlobalInstance from "../../js/shba";
import HotLabel from "../common/HotLabel";
export default {
  name: "OfficialNewsList",
  props: {
    path: {
      type: String,
      value: '',
    }
  },
  components: {
    BottomPaginator,
    HotLabel
  },
  data() {
    return {
      title: '新闻列表',
      itemList: null,
      pageIndex: 1,
      size: 10,
      count: 0,
      isLoading: false,
    }
  },
  computed: {
    currentIndex() {
      let index = GlobalInstance.methods.subTabIndex(this.$route);
      return index >=0 ? index : 0;
    },
    currentMenuItem() {
      return GlobalInstance.methods.currentMenuItem(this.$route);
    },
    totalPage() {
      let total = 0;
      if (this.count == 0) {
        total = 0;
      } else {
        total = Math.ceil(this.count / this.size);
      }
      return total;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    paginatorClicked(event) {
      let index = event.index;
      this.pageIndex = index;
      this.loadData();
    },

    loadData() {
      if (this.isLoading) {
        return;
      }
      let pageIndex = this.pageIndex;
      let params = {
        pageIndex,
        size: this.size,
        type: 4,
        tag: '全部'
      };
      this.isLoading = true;
      let _this = this;
      this.$store.state.http.ajax.vmActivities(params,function (data) {
        _this.isLoading = false;
        let code = data.code;
        if (code == 0) {
          let newList = data.data;
          _this.count = data.count;

          if (newList.length > 0) {
            _this.itemList = newList;
            return;
          }
        }

        _this.$toast('请求失败！');

      },function (data) {
        _this.isLoading = false;
        _this.$toast('请求失败，请重试！');
      });
    },
    itemSrc(item) {
      let web = item.newsUrl;
      if (web != null && web.length > 0) {
        return web;
      }
      return '/news/0301/0/' + item.id;
    },

    itemDate(item) {
      return this.$moment(item.createTime).format('yyyy.MM.DD');
    }
  }
}
</script>

<style scoped>

  #new_list_outer {
    width: 100%;
    padding-top: 0;
  }

  #new_list_outer li {
    border: none;
    padding-left: 0;
    padding-right: 0;
  }

  #new_list_outer ul {
    min-height: 300px;
  }

  #new_list_outer a {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    color: #666;
    font-size: 15px;
    text-decoration: none;
  }

  #new_list_outer a > div:first-child {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  #new_list_outer a:hover {
    color: #333;
  }

</style>



// WEBPACK FOOTER //
// src/components/news/OfficialNewsList.vue